import React from 'react';

export const stateReducer = (currentState, changes) => {

    // we compose a clean copy
    let newState = { ...currentState };

    if (changes) {

        let updated = false;

        // we merge changes
        for (let [k, v] of Object.entries(changes)) {

            if (undefined === newState[k] || v !== newState[k]) {
                newState[k] = v;
                updated = true;
            }
        }

        if (updated) {
            // we track the latest update
            newState.asOf = Date.now();
        }

    }

    return { ...newState };

}


export const LayoutContext = React.createContext(
    {
        layout: '',
        setLayout: (_) => { }
    }
);

export const InsuranceDataContext = React.createContext(
    {
        insuranceData: '',
        setInsuranceData: (_) => { }
    }
);

export const BrandingContext = React.createContext(
    {
        branding: '',
        setBranding: (_) => { }
    }
);

export const NotificationsContext = React.createContext(
    {
        notifications: '',
        setNotifications: (_) => { }
    }
);

export const ChatContext = React.createContext(
    {
        chat: '',
        setChat: (_) => { }
    }
);


export const ConfigurationContext = React.createContext(
    {
        configuration: '',
        setConfiguration: (_) => { }
    }
);


export const GeoContext = React.createContext(
    {
        geo: '',
        setGeo: (_) => { }
    }
);

export const QuestionnaireContext = React.createContext(
    {
        questions: {},
        setQuestions: (_) => { }
    }
);

export const QuoteContext = React.createContext(
    {
        quote: '',
        setQuote: (_) => { }
    }
);

export const SessionContext = React.createContext(
    {
        session: '',
        setSession: (_) => { }
    }
);

export const ViewContext = React.createContext(
    {
        view: '',
        setView: (_) => { }
    }
);

export const PhysicalContext = React.createContext(
    {
        physical: '',
        setPhysical: (_) => { }
    }
);
